const STRINGS = {
  continueButtonLabel: "Continue Session",
  bannerInstructionAnnoucement: "To continue your session, press any key or tap, click, or scroll screen.",
  warningBannerMessage: "For your security, this session is about to end due to inactivity."
};
export default STRINGS;